module.exports = __webpack_public_path__ + "img/noCoupon.e524084b.png";